import React from "react";
import { ViewComponent } from "./ViewComponent";
import { useDispatch, useSelector } from "react-redux";
import { useInputChange } from "../../../../hooks/useInputChange";
import { typeOrdersFilters } from "../../../../model/dashboardOrdersArchive/reducer";
import { typePaginationDashboardObject } from "../DashboardContentTable/PaginationDashboard/PaginationDashboard";
import {
  selectOrdersArchiveFilters,
  selectOrdersArchivePagination,
  selectOrdersArchiveSearchString,
} from "../../../../model/dashboardOrdersArchive/selectors";
import {
  dOrdersArchiveSetFiltersAC,
  dOrdersArchiveSetDataSagaAC,
  dOrdersArchiveClearFiltersAC,
  dOrdersArchiveSetPageNumberAC,
  dOrdersArchiveSetItemsForPageAC,
} from "../../../../model/dashboardOrdersArchive/actionCreators";

export type typeOrders = {
  variant?: string;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const DataOrdersArchive: React.FC<typeOrders> = ({
  variant,
  setSidebarOpen,
}) => {
  const dispatch = useDispatch();

  const filters = useSelector(selectOrdersArchiveFilters);
  const paginationObject = useSelector(selectOrdersArchivePagination);

  const searchString = useSelector(selectOrdersArchiveSearchString);

  const [openFilterBar, setOpenFilterBar] = React.useState(false);
  const [isActiveFilters, setIsActiveFilters] = React.useState(false);
  const [openPopupDetails, setOpenPopupDetails] = React.useState(false);

  const pagination: typePaginationDashboardObject = {
    paginationObject,
    onGoToPage: (id) => dispatch(dOrdersArchiveSetPageNumberAC(id)),
    onSelectItems: (itemsPerPage) => {
      return dispatch(dOrdersArchiveSetItemsForPageAC(itemsPerPage));
    },
  };

  React.useEffect(() => {
    return () => {
      dispatch(dOrdersArchiveClearFiltersAC());
    };
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(
      dOrdersArchiveSetDataSagaAC(filters, {
        page: pagination.paginationObject.pageNumber,
        size: pagination.paginationObject.itemsPerPage!,
      }),
    );
  }, [
    filters,
    dispatch,
    pagination.paginationObject.pageNumber,
    pagination.paginationObject.itemsPerPage,
  ]);

  const {
    value: searchValue,
    setValue: setSearchValue,
    changeValueHandler: onChangeSearchValueHandler,
  } = useInputChange(searchString || "");

  const onClearSearch = () => {
    dispatch(dOrdersArchiveSetFiltersAC({ searchString: null }));

    setSearchValue("");
  };

  const onEnterSearch = () => {
    const filters: typeOrdersFilters = {
      number: searchValue.trim(),
      externalId: searchValue.trim()
    };

    dispatch(dOrdersArchiveSetFiltersAC(filters));
  };

  return (
    <ViewComponent
      variant={variant}
      pagination={pagination}
      searchValue={searchValue}
      onEnterSearch={onEnterSearch}
      onClearSearch={onClearSearch}
      openFilterBar={openFilterBar}
      setSidebarOpen={setSidebarOpen}
      isActiveFilters={isActiveFilters}
      setOpenFilterBar={setOpenFilterBar}
      openPopupDetails={openPopupDetails}
      setIsActiveFilters={setIsActiveFilters}
      setOpenPopupDetails={setOpenPopupDetails}
      onChangeSearchValue={onChangeSearchValueHandler}
    />
  );
};
